var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCensusInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_898_135775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9199 24.0049L28.9199 24.0049C28.9092 23.9504 28.8822 23.899 28.8406 23.8573C28.8403 23.857 28.8399 23.8566 28.8396 23.8563L22.9333 18.0791L22.5679 17.7216L22.9333 17.3642L28.8396 11.5868C28.84 11.5864 28.8403 11.5861 28.8406 11.5857C28.8822 11.5441 28.9092 11.4927 28.9199 11.4382L28.9199 11.4381C28.9307 11.3835 28.9247 11.3267 28.9024 11.2746L28.9007 11.2707L28.9007 11.2707C28.8788 11.2184 28.8409 11.172 28.7901 11.1385C28.7392 11.1049 28.6785 11.0863 28.6157 11.0858H13.7378V24.3572H28.6158L28.9199 24.0049ZM28.9199 24.0049C28.9307 24.0596 28.9247 24.1163 28.9024 24.1684L28.9007 24.1723C28.8788 24.2246 28.8409 24.271 28.7901 24.3045L28.9199 24.0049ZM10.587 9.58953L10.5872 9.58936C10.6443 9.53332 10.7241 9.5 10.8096 9.5C10.895 9.5 10.9748 9.53332 11.0319 9.58933L11.0321 9.5895C11.089 9.64517 11.119 9.71851 11.119 9.79286V30.4071C11.119 30.5067 11.0648 30.6039 10.9681 30.6586C10.8704 30.7138 10.7487 30.7138 10.651 30.6586C10.5543 30.6039 10.5001 30.5066 10.5001 30.4071V9.79286C10.5001 9.71848 10.5302 9.64515 10.587 9.58953Z",
    fill: "white",
    stroke: "#0C6564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_898_135775",
    x: -2,
    y: -1,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_898_135775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_898_135775",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensusInactive);
export default __webpack_public_path__ + "static/media/CensusInactive.65aefaaf4bdf853c0a35a08d5cccf6f4.svg";
export { ForwardRef as ReactComponent };